import store                  from '@/store'
import { upperCaseFormatter } from '@/plugins/UpperCaseFormatterPlugin'



function getResponse(response) {
  if(response.status == 'error') {
    let errors = []

    console.log(response.data)

    for(let item of response.data.errors) {
      if(item.type == 'unique violation') {
        store.dispatch('createNotification', { title: 'Error', message: `Item "${upperCaseFormatter(item.path == 'id' ? 'name' : item.path)}": ${upperCaseFormatter(item.message)}` })
        errors[item.path == 'id' ? 'name' : item.path] = true
      } else {
        errors[item.name] = true
      }
    }

    if(response.model == 'User' && (response.requestData && response.requestData.currentPassword && response.requestData.password && response.requestData.confirmPassword)) {
      store.dispatch('createNotification', { title: 'Done', message: `You have an invalid password data!` })
    }

    return { errors }

  } else {
    if(response.status == 'success') {
      if(response.model != 'User') {
        const length =
        (response.data.sites && Array.isArray(response.data.sites) && Object.values(response.data.sites).length > 1) ? Object.values(response.data.sites).length
          : (response.data.key && Array.isArray(response.data.sites) && Object.values(response.data.key).length > 1) ? Object.values(response.data.key).length
            : (response.data && Array.isArray(response.data) && Object.values(response.data).length) ? Object.values(response.data).length
              : null

        if(length != null) {
          store.dispatch('createNotification', { title: 'Done', message: `Rows (${length}) have been ${response.type} successfully!` })
        } else {
          store.dispatch('createNotification', { title: 'Done', message: `${response.data.name ? `Row "${response.data.name}"` : 'The Row' } has been ${response.type} successfully!` })
        }
      } else {
        if(response.model == 'User' && (response.data.theme == true || response.data.theme == false)) {
          store.dispatch('createNotification', { title: 'Done', message: `Your theme is ${response.data.theme == true ? 'dark' : 'light'} now` })
        } else {
          if(response.model == 'User' && response.data.currentPassword && response.data.password && response.data.confirmPassword) {
            store.dispatch('createNotification', { title: 'Done', message: `Your password has been changed successfully!` })
          }
        }
      }
      return { success: response.data }
    }
  }
}



export default {
  install: (app, options) => {
    app.config.globalProperties.$responseChecker = (response) => { return getResponse(response) }
  }
}

export function responseChecker(response) {
  return getResponse(response)
}